import SectionHeading from "@/components/feature/SectionHeading";
import TopicCard from "@/components/feature/TopicCard";
import { topics } from "@/mocks/guaData";

export default function HomeGrid() {
  const collection = topics.filter((topic) => !topic.featured).slice(0, 6);

  return (
    <section className="w-full bg-background-50" aria-labelledby="collection-title">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="合集"
          title="全网热议事件合集"
          description="来自不同圈层的讨论焦点集中在这里。每条都附了事件脉络，点进去就能看懂前因后果。"
          linkTo="/rank"
          linkLabel="浏览全部话题"
        />
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {collection.map((topic) => (
            <TopicCard key={topic.id} topic={topic} />
          ))}
        </div>
      </div>
    </section>
  );
}